import React, { useEffect } from 'react'

import Intercom, { show, shutdown } from '@intercom/messenger-js-sdk'

import { useAuth } from './auth'

// Make Intercom show function available globally
declare global {
  interface Window {
    showIntercom: () => void
  }
}

export default function IntercomWrapper({
  children,
}: {
  children: React.ReactNode
}) {
  const { currentUser } = useAuth()

  useEffect(() => {
    if (currentUser) {
      Intercom({
        app_id: 'aakhsey6',
        user_id: currentUser.userId,
        name: `${currentUser.firstName} ${currentUser.lastName}`,
        email: currentUser.email,
        company: {
          company_id: currentUser.companyId,
          name: currentUser.companyName,
        },
        hide_default_launcher: true,
        alignment: 'left',
      })

      // Make show function available globally
      window.showIntercom = () => {
        show()
      }
    } else {
      // Clean up when user logs out to prevent privacy issues
      if (window.showIntercom) {
        delete window.showIntercom
      }
      // Shutdown Intercom to clear any stored user data
      shutdown()
    }
  }, [currentUser])

  return <>{children}</>
}
